// Верхняя полоса телефона и планшета (задача D5, ui-spec §6): уже 1024 сайдбара нет — «☰ {название экрана} {пилюля}
// {действие экрана}». «☰» открывает то же содержимое сайдбара в панели слева (240 / 180 мс, ловушка фокуса, Esc).
// Пункт меню нажат — панель закрывается. Название и действие ставит экран (PageShell); пока не поставил — полоса
// пишет название раздела сама.
import { Menu } from 'lucide-react';
import { useState } from 'react';
import { useLocation } from 'react-router';
import { useSection } from '@/app/section';
import { Button } from '@/components/ui/button';
import { Sheet, SheetContent, SheetTitle } from '@/components/ui/sheet';
import { SidebarContent } from './sidebar';
import { StatusPill } from './status-pill';
import { useTopbarSlot } from './topbar-slot';

export function MobileTopbar({
  onOpenPalette,
  onOpenShortcuts,
}: {
  readonly onOpenPalette: () => void;
  readonly onOpenShortcuts: () => void;
}) {
  const section = useSection();
  const topbar = useTopbarSlot();
  const { pathname } = useLocation();
  // Меню открыто на том экране, где его открыли: перешли на другой (из меню, ⌘K, ссылкой) — оно закрыто само.
  const [menuOpenAt, setMenuOpenAt] = useState<string | null>(null);
  const menuOpen = menuOpenAt === pathname;
  const setMenuOpen = (open: boolean): void => {
    setMenuOpenAt(open ? pathname : null);
  };

  return (
    <header className="flex h-14 items-center gap-1 border-b border-border px-2">
      <Sheet open={menuOpen} onOpenChange={setMenuOpen}>
        <Button
          variant="ghost"
          size="icon"
          aria-label="Меню"
          aria-expanded={menuOpen}
          onClick={() => {
            setMenuOpen(true);
          }}
        >
          <Menu aria-hidden="true" />
        </Button>
        <SheetContent side="left" className="w-72 max-w-[85vw] px-2 py-3">
          <SheetTitle className="sr-only">Меню пульта</SheetTitle>
          <SidebarContent
            onOpenPalette={() => {
              setMenuOpen(false);
              onOpenPalette();
            }}
            onOpenShortcuts={() => {
              setMenuOpen(false);
              onOpenShortcuts();
            }}
            onNavigate={() => {
              setMenuOpen(false);
            }}
          />
        </SheetContent>
      </Sheet>
      <div ref={topbar?.setTitleSlot} className="flex min-w-0 flex-1 items-center pl-1">
        {topbar !== null && topbar.claims === 0 && section !== undefined && (
          <span className="truncate text-md font-semibold">{section.titleRu}</span>
        )}
      </div>
      <StatusPill variant="topbar" announce />
      <div ref={topbar?.setActionsSlot} className="flex shrink-0 items-center gap-1" />
    </header>
  );
}
